export default __webpack_public_path__ + "static/media/5.3c4cb340.jpg";